import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Meal, AddOn } from 'src/services/classes/models/order-item';
import { Logger } from 'src/services/core/logger/logger.service';

const log = new Logger('Cart');
@Injectable({
  providedIn: 'root',
})
export class CartService {
  cart: Map<string, Meal[]> = new Map();
  cartTotal = 0;
  cartUpdate: BehaviorSubject<{ cartUpdate: boolean }> = new BehaviorSubject<{
    cartUpdate: boolean;
  }>({ cartUpdate: false });

  constructor() {}

  getCartItems(): Map<string, Meal[]> {
    // @ts-ignore
    const cart = JSON.parse(localStorage.getItem('cart'), this.reviver);
    return cart;
  }

  addDishToCart(meal: Meal, quantityOrdered: number) {
    if (localStorage.getItem('cart')) {
      // @ts-ignore
      this.cart = JSON.parse(localStorage.getItem('cart'), this.reviver);
    }

    meal['quantityOrdered'] = quantityOrdered;
    let n = 1;
    while (this.cart.has(`Dish ${n}`)) {
      n++;
    }
    this.cart.set(`Dish ${n}`, [meal]);
    this.cartSubmission();
  }

  removeDishFromCart(dishIndex: string) {
    if (localStorage.getItem('cart')) {
      // @ts-ignore
      this.cart = JSON.parse(localStorage.getItem('cart'), this.reviver);
    }

    this.cart.delete(dishIndex);

    setTimeout(() => this.cartSubmission(this.cart.size > 0 ? true : false), 5);
  }

  // Though Process: add a parameter for dishIndex,
  // use it to check if a dish exists in the cart
  // if the dish exists, there was probably just a change in the addOns config
  // OR a meal is about to be added to the dish
  addMealToDishInCart(meal: Meal, quantityOrdered: number, dishIndex: string) {
    console.log('Adding meal to dish in cart:', meal);
    console.log('Dish index:', dishIndex);
    
    if (localStorage.getItem('cart')) {
      // @ts-ignore
      this.cart = JSON.parse(localStorage.getItem('cart'), this.reviver);
      console.log('Existing cart from localStorage:', this.cart);
    }

    meal['quantityOrdered'] = quantityOrdered;

    if (this.cart.has(dishIndex)) {
      let mealArray = this.cart.get(dishIndex) || [];
      mealArray.splice(mealArray.length - 1, 0, meal);
      console.log('Updated meal array for dish:', mealArray);
    }

    console.log('Updated cart before submission:', this.cart);
    this.cartSubmission();
  }

  updateMealInDishInCart(
    meal: Meal,
    quantityOrdered: number,
    dishIndex: string,
    mealIndex: number
  ) {
    if (localStorage.getItem('cart')) {
      // @ts-ignore
      this.cart = JSON.parse(localStorage.getItem('cart'), this.reviver);
    }

    meal['quantityOrdered'] = quantityOrdered;

    if (this.cart.has(dishIndex)) {
      let mealArray = this.cart.get(dishIndex) || [];
      mealArray.splice(mealIndex, 1, meal);
    }

    this.cartSubmission();
  }

  removeMealFromDishInCart(dishIndex: string, mealIndex: number) {
    if (localStorage.getItem('cart')) {
      // @ts-ignore
      this.cart = JSON.parse(localStorage.getItem('cart'), this.reviver);
    }

    if (this.cart.has(dishIndex)) {
      let mealArray = this.cart.get(dishIndex) || [];
      mealArray.splice(mealIndex, 1);
    }

    setTimeout(() => this.cartSubmission(), 5);
  }

  addAddonsToDishInCart(dishIndex: string, mealIndex: number, addOns: AddOn[]) {
    // Implementation here
    if (localStorage.getItem('cart')) {
      // @ts-ignore
      this.cart = JSON.parse(localStorage.getItem('cart'), this.reviver);
    }

    let dish = this.cart.get(dishIndex);
    if (Array.isArray(dish)) {
      // @ts-ignore
      const meal: Meal = dish.find(
        (item: Meal, index: number) => mealIndex === index
      );
      if (meal) {
        if (meal.addOns && meal.addOns.length > 0) {
          meal.addOns = [...meal.addOns, ...addOns];
        } else {
          meal.addOns = addOns;
        }
      }
    }

    this.cartSubmission();
  }

  removeAddonFromDishInCart(
    dishIndex: string,
    mealIndex: number,
    addOnIndex: number
  ) {
    if (localStorage.getItem('cart')) {
      // @ts-ignore
      this.cart = JSON.parse(localStorage.getItem('cart'), this.reviver);
    }

    let dish = this.cart.get(dishIndex);
    if (Array.isArray(dish)) {
      // @ts-ignore
      const meal: Meal = dish.find(
        (item: Meal, index: number) => mealIndex === index
      );

      if (meal) {
        // @ts-ignore
        meal?.addOns.splice(addOnIndex, 1);
      }
    }

    this.cartSubmission();
  }

  changeQuantityOfDishItemInCart(type: string, dishIndex: string) {
    // Implementation here
    if (localStorage.getItem('cart')) {
      // @ts-ignore
      this.cart = JSON.parse(localStorage.getItem('cart'), this.reviver);
    }

    let dish = this.cart.get(dishIndex);
    this.cartSubmission();
  }

  clearCart() {
    if (localStorage.getItem('cart')) {
      // @ts-ignore
      this.cart = JSON.parse(localStorage.getItem('cart'), this.reviver);
    }

    this.cart.clear();
    this.cartSubmission();
  }

  cartSubmission(handleDishIndexUpdate = false) {
    if (handleDishIndexUpdate === true) {
      const newCart = [];
      let countToIncrease = 0;
      for (let entry of this.cart.entries()) {
        let currentEntry: [string, Meal[]] = [...entry];
        entry.splice(0, 1, `Dish ${countToIncrease + 1}`);
        newCart.push(entry);
        countToIncrease++;
        this.cart.delete(currentEntry[0]);
      }

      newCart.forEach((entry: [string, Meal[]]) =>
        this.cart.set(entry[0], entry[1])
      );
    }

    this.cartTotal = 0;

    // Get cartTotal here
    this.cart.forEach((item) => {
      if (Array.isArray(item)) {
        item.forEach((element: Meal) => {
          this.cartTotal =
            // @ts-ignore
            this.cartTotal + +element.price * +element?.quantityOrdered;

          if (element.addOns) {
            element.addOns.forEach((addOn: AddOn) => {
              addOn.quantityOrdered = element.quantityOrdered;
              if (addOn.quantityOrdered && Number(addOn.quantityOrdered > 1)) {
                // checking to ensure we are not going beyond the stock-count
                if (Number(addOn.stockCount) >= Number(addOn.quantityOrdered)) {
                  this.cartTotal += +addOn.price * +addOn.quantityOrdered;
                } else {
                  // if the remaining stock-count is less than the quantity ordered
                  this.cartTotal +=
                    // @ts-ignore
                    +addOn?.stockCount > 0
                      ? // @ts-ignore
                        +addOn.price * +addOn?.stockCount
                      : +addOn.price;
                }
              } else {
                this.cartTotal += +addOn.price;
              }
            });
          }
        });
      }
    });

    // Set up cart in localStorage
    localStorage.setItem('cart', JSON.stringify(this.cart, this.replacer));
    localStorage.setItem('cartTotal', JSON.stringify(this.cartTotal));
    console.log('Final cart saved to localStorage:', this.cart);
    console.log('Cart total saved to localStorage:', this.cartTotal);
    
    this.cartUpdate.next({ cartUpdate: true });
    setTimeout(() => this.cartUpdate.next({ cartUpdate: false }), 1000);

    log.debug('after-action: ', this.cart);
  }

  // Helper functions
  // https://stackoverflow.com/a/56150320
  public replacer(key: any, value: any) {
    if (value instanceof Map) {
      return {
        dataType: 'Map',
        value: [...value],
      };
    } else {
      return value;
    }
  }

  public reviver(key: any, value: any) {
    if (typeof value === 'object' && value !== null) {
      if (value.dataType === 'Map') {
        return new Map(value.value);
      }
    }
    return value;
  }

  // Usage
  /**
   * const originalValue = new Map([['a', 1]]);
   * const str = JSON.stringify(originalValue, replacer);
   * const newValue = JSON.parse(str, reviver);
   * console.log(originalValue, newValue);
   */

  updateMealTakeoutStatus(dishIndex: string, mealIndex: number, takeoutStatus: boolean) {
    if (localStorage.getItem('cart')) {
      // @ts-ignore
      this.cart = JSON.parse(localStorage.getItem('cart'), this.reviver);
    }

    if (this.cart.has(dishIndex)) {
      let mealArray = this.cart.get(dishIndex) || [];
      if (mealArray[mealIndex]) {
        mealArray[mealIndex].takeout = takeoutStatus;
      }
    }

    this.cartSubmission();
  }

  updateCartItem(meal: Meal) {
    if (localStorage.getItem('cart')) {
      // @ts-ignore
      this.cart = JSON.parse(localStorage.getItem('cart'), this.reviver);
    }

    this.cart.forEach((meals, dishKey) => {
      const mealIndex = meals.findIndex(m => m.id === meal.id);
      if (mealIndex !== -1) {
        meals[mealIndex] = { ...meals[mealIndex], takeout: meal.takeout };
        this.cart.set(dishKey, meals);
      }
    });

    this.cartSubmission();
  }
}